import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchWithAuth } from "../../../Context/UserContext";
import PageLayout from "../../../components/layout/PageLayout";
import API_URL from "../../../config";
import { Card, CardContent } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { toast } from "sonner";

const ConfirmarEdicion = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const formData = location.state?.formData || {}; // Obtener el formData desde la navegación

  const handleConfirm = async () => {
    try {
      const response = await fetchWithAuth(
        `${API_URL}/licit/update_tender/${formData.id_tender}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        toast.success("Licitación actualizada exitosamente");
        navigate("/mis-licitaciones");
      } else {
        const errorData = await response.json();
        toast.error(`Error: ${errorData.error}`);
      }
    } catch (error) {
      console.error("Error al actualizar la licitación:", error);
      toast.error("Hubo un error al intentar actualizar la licitación.");
    }
  };

  const handleEditSection = (step) => {
    const stepPaths = {
      general: "/create-tender-step-2",
      additional: "/create-tender-step-3",
      questions: "/create-tender-step-4",
    };
    navigate(stepPaths[step], {
      state: { formData: { ...formData, isEditing: true } },
    });
  };

  return (
    <PageLayout>
      <div className="mx-auto max-w-3xl space-y-4 px-4 py-8 sm:px-6">
        <h3 className="text-xl font-semibold text-foreground">Confirmar Edición de Licitación</h3>

        <Card>
          <CardContent className="space-y-2 pt-6">
            <div className="flex items-center justify-between">
              <h4 className="font-semibold text-foreground">Información General</h4>
              <Button variant="outline" size="sm" onClick={() => handleEditSection("general")}>
                Editar
              </Button>
            </div>
            <p className="text-sm text-muted-foreground">
              <strong className="text-foreground">Título:</strong> {formData.titulo}
            </p>
            <p className="text-sm text-muted-foreground">
              <strong className="text-foreground">Categoría:</strong> {formData.categoria}
            </p>
            <p className="text-sm text-muted-foreground">
              <strong className="text-foreground">Descripción:</strong>{" "}
              <span
                dangerouslySetInnerHTML={{
                  __html: (formData.descripcion || "").replace(/\n/g, "<br>"),
                }}
              />
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="space-y-2 pt-6">
            <div className="flex items-center justify-between">
              <h4 className="font-semibold text-foreground">Información Adicional</h4>
              <Button variant="outline" size="sm" onClick={() => handleEditSection("additional")}>
                Editar
              </Button>
            </div>
            <p className="text-sm text-muted-foreground">
              <strong className="text-foreground">Ciudades donde se dará el servicio:</strong>{" "}
              {Array.isArray(formData.ciudad) ? formData.ciudad.join(", ") : "No especificado"}
            </p>
            <p className="text-sm text-muted-foreground">
              <strong className="text-foreground">Condiciones de Pago:</strong>{" "}
              {Array.isArray(formData.condiciones_pago) ? formData.condiciones_pago.join(", ") : "No especificado"}
            </p>
          </CardContent>
        </Card>

        {Array.isArray(formData.preguntas_licitador) && formData.preguntas_licitador.length > 0 ? (
          <Card>
            <CardContent className="space-y-2 pt-6">
              <div className="flex items-center justify-between">
                <h4 className="font-semibold text-foreground">Preguntas para el Postulante</h4>
                <Button variant="outline" size="sm" onClick={() => handleEditSection("questions")}>
                  Editar
                </Button>
              </div>
              <ul className="space-y-1 text-sm text-muted-foreground">
                {formData.preguntas_licitador.map((q, index) => (
                  <li key={index}>
                    {index + 1}. {q.question} <span className="text-xs">({q.type})</span>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ) : (
          <p className="text-sm text-muted-foreground">No se han configurado preguntas para los postulantes.</p>
        )}

        <div className="flex gap-2">
          <Button variant="outline" onClick={() => navigate("/mis-licitaciones")}>
            Regresar
          </Button>
          <Button onClick={handleConfirm}>Confirmar cambios</Button>
        </div>
      </div>
    </PageLayout>
  );
};

export default ConfirmarEdicion;
